// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"CompaniesPage_noMargin__1E47d","searchWrap":"CompaniesPage_searchWrap__2oIBc"};